export default {
      id: "notSeen-usage",
      viewBox: "0 0 24 24",
      url: "assets/" + "sprite.svg#notSeen-usage",
      toString: function () {
        return this.url;
      }
    }